import { ButtonHTMLAttributes, ReactNode } from "react";
import { Loader } from "lucide-react";

type Variant = "primary" | "success" | "secondary" | "neutral" | "danger" | "danger-solid";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  fullWidth?: boolean;
  icon?: ReactNode;
  children: ReactNode;
}

const variantClass: Record<Variant, string> = {
  primary: "btn-primary",
  success: "btn-success",
  secondary: "btn-secondary",
  neutral: "btn-neutral",
  danger: "btn-danger",
  "danger-solid": "btn-danger-solid",
};

export default function Button({
  variant = "primary",
  loading = false,
  fullWidth = false,
  icon,
  children,
  className = "",
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      className={`${variantClass[variant]} ${fullWidth ? "w-full" : ""} ${className}`}
    >
      {loading ? <Loader className="w-4 h-4 animate-spin" /> : icon}
      {children}
    </button>
  );
}
